import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";
import { ISaveAdminBusiness } from "app/models/admin/admin";
import { IBusinessView } from "app/models/business/business";
// import { IBusinessView } from "app/models/mainMenu/mainMenu";
import { IReportSelectItems, ISelectItems } from "app/models/shared/shared";
import { AdminService } from "app/services/admin/admin.service";
import { BusinessService } from "app/services/business/business.service";


@Component({
  selector: 'editBusinessInfo',
  styleUrls: ['./editBusinessInfo.component.scss'],
  templateUrl: './editBusinessInfo.component.html'
})

export class EditBusinessInfoComponent implements OnInit {

  stateList: string[] = [];
  currentBusiness: IBusinessView = {} as IBusinessView;
  businessList: ISelectItems[] = [];
  savedBusiness: boolean = false;
  showInformation:boolean = false;

  currentSave: ISaveAdminBusiness = {
    businessId: 0,
    businessName: '',
    businessType: 0,
    active: false,
    exempt: false,
    businessAddress1: '',
    businessAddress2: '',
    businessCity: '',
    businessZip: '',
    businessZipExt: '',
    countyId: '',
    exemptCertificateDate: '',
    exemptStatusId: '',
    exemptTypeId: '',
    exemptSmokingAllowed: false,
    exemptApprovedBy: '',
    exemptEnteredBy: ''
  };

  businessForm = new UntypedFormGroup({
    // id: new UntypedFormControl('', [Validators.maxLength(50)]),
    // businessType: new UntypedFormControl(''),
    // status: new UntypedFormControl(''),
    // exempt: new UntypedFormControl(''),
    // exemptCertificateDate: new UntypedFormControl(''),
    // exemptStatus: new UntypedFormControl(''),
    // exemptType: new UntypedFormControl(''),
    // exemptSmokingAllowed: new UntypedFormControl(''),
    // countyName: new UntypedFormControl(''),
    // businessPhoneNum: new UntypedFormControl(''),
    businessPhone: new UntypedFormControl(''),
    businessPhoneExt: new UntypedFormControl(''),
    contactTitle: new UntypedFormControl(''),
    contactEmail: new UntypedFormControl(''),
    businessOwner: new UntypedFormControl(''),
    businessOwnerTitle: new UntypedFormControl(''),
    businessOwnerPhone: new UntypedFormControl(''),
    businessOwnerEmail: new UntypedFormControl(''),
    parentBusinessId: new UntypedFormControl({ value: '', disabled: true }),
    parentBusinessName: new UntypedFormControl(''),
    parentBusinessContactName: new UntypedFormControl(''),
    parentBusinessContactFirstName: new UntypedFormControl(''),
    parentBusinessContactLastName: new UntypedFormControl(''),
    parentBusinessContactTitle: new UntypedFormControl(''),
    parentBusinessAddress: new UntypedFormControl(''),
    parentBusinessAddress2: new UntypedFormControl(''),
    parentBusinessCity: new UntypedFormControl(''),
    parentBusinessState: new UntypedFormControl(''),
    parentBusinessZip: new UntypedFormControl(''),
    parentBusinessZipExt: new UntypedFormControl(''),
    // parentBusinessPhoneNum: new UntypedFormControl(''),
    parentBusinessPhone: new UntypedFormControl(''),
    parentBusinessPhoneExt: new UntypedFormControl(''),
    parentBusinessEmail: new UntypedFormControl(''),
    useParentBusinessContact: new UntypedFormControl(''),
  });

  constructor(
    private sharedService: SharedService,
    private adminService: AdminService,
    private businessService: BusinessService,
    private dialogRef: MatDialogRef<EditBusinessInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.currentBusiness = this.data.business;
    this.setForm(this.currentBusiness);
  }

  ngOnInit(): void {
    this.businessList = this.sharedService.businessTypeDropDownList;
    this.savedBusiness = false;
    this.stateList = this.sharedService.stateList;
  }

  save() {
    if (this.businessForm.valid) {
      this.setSaveData();
      this.businessService.saveBusinessInfo(this.currentBusiness).subscribe({
        next: response => {
          this.sharedService.toastr.success("Business Info Saved");
          this.savedBusiness = true;
          // this.dialogRef.close('saved');
        },
        error: e => {
          this.sharedService.toastr.error("Could not save Business Info");
        },
      });
    }
    else {
      this.sharedService.toastr.error("Form is not valid");
    }
  }

  showInfo(){
    this.showInformation = !this.showInformation;
  }

  setForm(data:IBusinessView){
    this.businessForm.patchValue({
      // id: data.id,
      // businessType: data.businessType,
      // status: data.active,
      // exempt: data.exempt,
      // exemptCertificateDate: data.exemptCertificateDate,
      // exemptStatus: data.exemptStatus,
      // exemptType: data.exemptType,
      // exemptSmokingAllowed: data.exemptSmokingAllowed,
      // countyName: data.countyName,
      // businessPhoneNum: data.businessPhone + ' ' + (data.businessPhoneExt == '' ? '' : ' x' + data.businessPhoneExt),
      businessPhone: data.businessPhone,
      businessPhoneExt: data.businessPhoneExt,
      contactTitle: data.contactTitle,
      contactEmail: data.contactEmail,
      businessOwner: data.businessOwner,
      businessOwnerTitle: data.businessOwnerTitle,
      businessOwnerPhone: data.businessOwnerPhone,
      businessOwnerEmail: data.businessOwnerEmail,
      parentBusinessId: data.parentBusinessId,
      parentBusinessName: data.parentBusinessName,
      parentBusinessContactName: data.parentBusinessContactFirstName + ' ' + data.parentBusinessContactLastName,
      parentBusinessContactFirstName: data.parentBusinessContactFirstName,
      parentBusinessContactLastName: data.parentBusinessContactLastName,
      parentBusinessContactTitle: data.parentBusinessContactTitle,
      parentBusinessAddress: data.parentBusinessAddress,
      parentBusinessAddress2: data.parentBusinessAddress2,
      parentBusinessCity: data.parentBusinessCity,
      parentBusinessState: data.parentBusinessState,
      parentBusinessZip: data.parentBusinessZip,
      // parentBusinessPhoneNum: data.parentBusinessPhone + ' ' + (data.parentBusinessPhoneExt == '' ? '' : ' x' + data.parentBusinessPhoneExt),
      parentBusinessPhone: data.parentBusinessPhone,
      parentBusinessPhoneExt: data.parentBusinessPhoneExt,
      parentBusinessEmail: data.parentBusinessEmail,
      useParentBusinessContact: data.useParentBusinessContact,
    });
  }

  setSaveData(){
    this.currentBusiness.businessPhone = this.businessForm.get('businessPhone').value;
    this.currentBusiness.businessPhoneExt = this.businessForm.get('businessPhoneExt').value;
    this.currentBusiness.contactTitle = this.businessForm.get('contactTitle').value;
    this.currentBusiness.contactEmail = this.businessForm.get('contactEmail').value;
    this.currentBusiness.businessOwner = this.businessForm.get('businessOwner').value;
    this.currentBusiness.businessOwnerTitle = this.businessForm.get('businessOwnerTitle').value;
    this.currentBusiness.businessOwnerPhone = this.businessForm.get('businessOwnerPhone').value;
    this.currentBusiness.businessOwnerEmail = this.businessForm.get('businessOwnerEmail').value;
    this.currentBusiness.parentBusinessId = this.businessForm.get('parentBusinessId').value;
    this.currentBusiness.parentBusinessName = this.businessForm.get('parentBusinessName').value;
    this.currentBusiness.parentBusinessContactFirstName = this.businessForm.get('parentBusinessContactFirstName').value;
    this.currentBusiness.parentBusinessContactLastName = this.businessForm.get('parentBusinessContactLastName').value;
    this.currentBusiness.parentBusinessContactTitle = this.businessForm.get('parentBusinessContactTitle').value;
    this.currentBusiness.parentBusinessAddress = this.businessForm.get('parentBusinessAddress').value;
    this.currentBusiness.parentBusinessAddress2 = this.businessForm.get('parentBusinessAddress2').value;
    this.currentBusiness.parentBusinessCity = this.businessForm.get('parentBusinessCity').value;
    this.currentBusiness.parentBusinessState = this.businessForm.get('parentBusinessState').value;
    this.currentBusiness.parentBusinessZip = this.businessForm.get('parentBusinessZip').value;
    this.currentBusiness.parentBusinessPhone = this.businessForm.get('parentBusinessPhone').value;
    this.currentBusiness.parentBusinessPhoneExt = this.businessForm.get('parentBusinessPhoneExt').value;
    this.currentBusiness.parentBusinessEmail = this.businessForm.get('parentBusinessEmail').value;
    this.currentBusiness.useParentBusinessContact = this.businessForm.get('useParentBusinessContact').value;
  }

  businessType(typeId: number) {
    if (typeId == null || typeId == undefined) {
      return '';
    }
    let type = this.businessList.find(x => x.value == typeId.toString());
    return type ? type.text : '';
  }

  return(): void {
    let returnData = this.savedBusiness ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }

}